<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title">
          <a-icon type="file-search" />&nbsp;Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model.lazy="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="searchDate"
                    :format="getDefaultDateFormat" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select placeholder="Ex: Project ... " v-model="kategori" class="width-full" allowClear>
                    <a-select-option v-for="item in getKategori" :key="item.id"
                      :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="matauang">Currency</label>
                  <a-select placeholder="Select Currency" v-model="matauang" class="width-full" initialValue allowClear>
                    <a-select-option v-for="item in getAllMataUang" :key="item.code" :value="item.code">{{ item.code }} -
                      {{ item.currency }}</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option v-for="item in getStatus" :key="item.id"
                      :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="UM PP Report List" :manifestLink="getManifestLink" :dataList="dataListOutput"
        :price="true" :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "listUMPP",
  mixins: [CurrencyFormat],
  props: ["prnMenu"],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      kategori: undefined,
      searchDate: [],
      search: "",
      status: undefined,
      matauang: undefined,
    };
  },
  mounted() {
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            (obj.no_lk !== null ? obj.no_lk.toLowerCase() : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            (obj.tanggal !== null || obj.tanggal !== ""
              ? this.moment(obj.tanggal).format(this.getDefaultDateFormat)
              : ""
            )
              .toString()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.total_pemakaian &&
              this.formatCurrency(obj.currency, obj.total_pemakaian)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            obj.tlc_pembuat.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);

        outputData = outputData.filter(
          (obj) =>
            obj.tgl_buat &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.kategori) {
        outputData = _.filter(outputData, { peruntukan: self.kategori });
      }

      if (this.matauang) {
        outputData = _.filter(outputData, { currency: self.matauang });
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return outputData;
    },
    dataListOutput() {
      let output = [];

      _.forEach(this.searching, (data) => {
        output.push({
          title: data.no_lk,
          timeline: JSON.parse(data.status_app),
          unread: data.unread == "1" ? true : false,
          subdesc: [
            this.moment(data.tgl_buat).format(this.getDefaultDateFormat),
            this.formatCurrency(data.currency, data.total_pemakaian),
            "Type : " + (data.isparsial == "1" ? "PARSIAL" : "FINAL")
          ],
          status: data.status,
          id: data.id_manifest,
          price: data.grand_total,
        });
      });
      return output;
    },
    getManifestLink() {
      let manifest = "";
      if (localStorage.getItem("nvpn") === "/keuangan") {
        manifest = "SpclLapUMPPManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        manifest = "SpclLapUMPPManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        manifest = "SpclLapUMPPManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        manifest = "SpclLapUMPPManifestDir";
      } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
        manifest = "SpclLapUMPPManifestVP";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        manifest = "SpclLapUMPPManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclLapUMPPManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclLapUMPPManifestFin";
      } else {
        manifest = "SpclLapUMPPManifest_";
      }

      return manifest;
    },
  },
  methods: {
    moment,
    fetchData() {
      const laporan = axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/lap_um_pp",
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
          jenis: "Laporan",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          laporan.catch((err) => {
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {
            this.dataList = response[0].data.data;
            this.basedList = response[0].data.data;
          } else {
            this.dataList = [];
            this.basedList = [];
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>